export default __webpack_public_path__ + "static/media/factory__31.1d55528f.jpg";